var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerifyFactor4X(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 17,
    fill: "#DCDCDC",
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0627 12.8596L23.3691 11.5821L19.4828 3.61624C19.3766 3.39814 19.202 3.22158 18.9863 3.11426C18.4453 2.84423 17.7879 3.06925 17.5174 3.61624L13.6311 11.5821L4.93745 12.8596C4.69777 12.8942 4.47863 13.0085 4.31085 13.1816C4.10802 13.3923 3.99624 13.6759 4.0001 13.97C4.00395 14.264 4.12311 14.5445 4.33139 14.7498L10.6214 20.9501L9.13532 29.7054C9.10047 29.909 9.12276 30.1185 9.19967 30.31C9.27657 30.5015 9.405 30.6674 9.57041 30.7889C9.73581 30.9103 9.93157 30.9825 10.1355 30.9972C10.3394 31.0119 10.5433 30.9685 10.7241 30.872L18.5001 26.7385L26.2761 30.872C26.4884 30.9863 26.7349 31.0244 26.9711 30.9828C27.5669 30.879 27.9675 30.3077 27.8648 29.7054L26.3788 20.9501L32.6687 14.7498C32.8399 14.5802 32.9529 14.3586 32.9872 14.1163C33.0796 13.5104 32.6619 12.9496 32.0627 12.8596V12.8596Z",
    fill: "#F5F5F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0234 14.5469L13.4219 17.1172L14.8594 14.5469H17.2578L14.8672 18.6797L17.3672 23H14.9609L13.4375 20.2813L11.9141 23H9.50781L12.0078 18.6797L9.61719 14.5469H12.0234ZM26.2266 18.75V20.5156H18.0312L17.9219 19.1484L22.6641 11.625H24.4531L22.5156 14.8672L20.1562 18.75H26.2266ZM24.9375 11.625V23H22.6875V11.625H24.9375Z",
    fill: "#5A5A5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifyFactor4X);
export default __webpack_public_path__ + "static/media/verify_factor4x.d32a13bcf686f1517ba9e21f93407bfd.svg";
export { ForwardRef as ReactComponent };